var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCorrect = function SvgCorrect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4293",
    "data-name": "Group 4293",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48087",
    "data-name": "Path 48087",
    d: "M190.694,295.224a13,13,0,1,1-13,13,13,13,0,0,1,13-13Zm0,1.872a11.128,11.128,0,1,0,11.128,11.128A11.128,11.128,0,0,0,190.694,297.1Z",
    transform: "translate(-177.694 -295.224)",
    fill: "#379824",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48088",
    "data-name": "Path 48088",
    d: "M309.268,470.727h0a.935.935,0,0,1,1.322-.027l3.889,3.776,7.508-8.647a.939.939,0,0,1,1.318-.1h0a.936.936,0,0,1,.1,1.318l-8.141,9.376a.94.94,0,0,1-1.2.186.915.915,0,0,1-.247-.171l-4.521-4.391A.939.939,0,0,1,309.268,470.727Z",
    transform: "translate(-303.32 -458.128)",
    fill: "#379824",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCorrect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/correct.eaff03d0.svg";
export { ForwardRef as ReactComponent };